import type { RegionData } from "@components/region-map-display";

// DANE - tutaj zarządzasz przypisaniami powiatów
export const COUNTY_ASSIGNMENTS: RegionData[] = [
  // Dodaj więcej powiatów tutaj:
  {
    color: "#000",
    email: "a.wozniczka@kns-okna.pl",
    pathId: "",
    phone: "+48 514 602 064",
    salesRepName: "Andrzej Woźniczka",
    title: "Dyrektor Handlowy",
  },
  {
    color: "#3B82F6",
    email: "p.mueller@kns-okna.pl",
    pathId: [
      "głubczycki",
      "kędzierzyńsko-kozielski",
      "raciborski",
      "krapkowicki",
      "strzelecki",
      "lubliniecki",
      "myszkowski",
      "zawierciański",
      "miechowski",
      "jędrzejowski",
      "krakowski",
      "olkuski",
      "wadowicki",
      "suski",
      "żywiecki",
      "cieszyński",
      "Jastrzębie-Zdrój",
      "wodzisławski",
      "rybnicki",
      "Rybnik",
      "gliwicki",
      "Gliwice",
      "tarnogórski",
      "będziński",
      "Dąbrowa Górnicza",
      "chrzanowski",
      "Jaworzno",
      "Sosnowiec",
      "oświęcimski",
      "bielski",
      "Bielsko-Biała",
      "pszczyński",
      "bieruńsko-lędziński",
      "Mysłowice",
      "Katowice",
      "Tychy",
      "mikołowski",
      "Żory",
      "Zabrze",
      "Ruda Śląska",
      "Bytom",
      "Piekary Śląskie",
      "Siemianowice Śląskie",
      "Chorzów",
      "Świętochłowice",
    ],
    phone: "+48 533 923 215",
    salesRepName: "Paweł Mueller",
  },
  {
    color: "#EF4444",
    email: "c.janiszewski@kns-okna.pl",
    pathId: [
      "policki",
      "Szczecin",
      "gryfiński",
      "myśliborski",
      "gorzowski",
      "Gorzów Wielkopolski",
      "strzelecko-drezdenecki",
      "wałecki",
      "choszczeński",
      "pyrzycki",
      "stargardzki",
      "drawski",
      "świdwiński",
      "białogardzki",
      "łobeski",
      "goleniowski",
      "kołobrzeski",
      "gryficki",
      "kamieński",
      "Świnoujście",
      "czarnkowsko-trzcianecki",
      "chodzieski",
      "słubicki",
      "sulęciński",
      "międzyrzecki",
      "międzychodzki",
      "świebodziński",
      "nowotomyski",
      "krośnieńskii",
      "zielonogórski",
      "wolsztyński",
      "obornicki",
      "wągrowiecki",
      "żarski",
      "żagański",
      "wschowski",
      "lesczyński",
      "Leszno",
      "rawicki",
      "krotoszyński",
      "ostrowski",
    ],
    phone: "+48 514 602 070",
    salesRepName: "Cezary Janiszewski",
  },
  {
    color: "#FECC00",
    email: "j.bilkowski@kns-okna.pl",
    pathId: [
      "sejneński",
      "augustowski",
      "sokólski",
      "białostocki",
      "Białystok",
      "hajnowski",
      "bielskii",
      "siemiatycki",
      "łosicki",
      "siedlecki",
      "Siedlce",
      "miński",
      "garwoliński",
      "otwocki",
      "piaseczyński",
      "grójecki",
      "rawski",
      "tomaszowskii",
      "opoczyński",
      "konecki",
      "włoszczowski",
      "częstochowski",
      "Częstochowa",
      "kłobucki",
      "pajęczański",
      "radomszczański",
      "wieruszowski",
      "ostrzeszowski",
      "kaliski",
      "Kalisz",
      "pleszewski",
      "jarociński",
      "gostyński",
      "kościański",
      "grodziski",
      "poznański",
      "Poznań",
      "szamotulski",
      "żniński",
      "bydgoski",
      "Bydgoszcz",
      "toruński",
      "Toruń",
      "aleksandrowski",
      "włocławski",
      "Włocławek",
      "płocki",
      "Płock",
      "gostyniński",
      "płoński",
      "ciechanowski",
      "makowski",
      "ostrołęcki",
      "Ostrołęka",
      "łomżyński",
      "Łomża",
      "grajewski",
      "moniecki",
      "zambrowski",
      "wysokomazowiecki",
      "ostrowskii",
      "sokołowski",
      "węgrowski",
      "wołomiński",
      "wyszkowski",
      "pułtuski",
      "legionowski",
      "Warszawa",
      "nowodworski",
      "warszawski zachodni",
      "pruszkowski",
      "grodziski",
      "żyrardowski",
      "skierniewicki",
      "Skierniewice",
      "sochaczewski",
      "łowicki",
      "kutnowski",
      "piotrkowski",
      "Piotrków Trybunalski",
      "bełchatowski",
      "łaski",
      "zduńskowolski",
      "sieradzki",
      "pabianicki",
      "łódzki wschodni",
      "brzeziński",
      "Łódź",
      "zgierski",
      "poddębicki",
      "łęczycki",
      "kolski",
      "turecki",
      "koniński",
      "Konin",
      "radziejowski",
      "inowrocławski",
      "mogileński",
      "słupecki",
      "gnieźnieński",
      "wrzesiński",
      "średzkii",
      "śremski",
      "wieluński",
      "kępiński",
    ],
    phone: "+48 501 617 620",
    salesRepName: "Jacek Bilkowski",
  },
  {
    color: "#009846",
    email: "t.kos@kns-okna.pl",
    pathId: [
      "tatrzański",
      "nowotarski",
      "myślenicki",
      "Kraków",
      "wielicki",
      "proszowicki",
      "kazimierski",
      "pińczowski",
      "buski",
      "staszowski",
      "opatowski",
      "ostrowiecki",
      "starachowicki",
      "skarżyski",
      "szydłowiecki",
      "białobrzeski",
      "kozienicki",
      "rycki",
      "łukowski",
      "radzyński",
      "bialski",
      "Biała Podlaska",
      "włodawski",
      "parczewski",
      "lubartowski",
      "puławski",
      "zwoleński",
      "radomski",
      "Radom",
      "lipski",
      "opollski",
      "lubelski",
      "Lublin",
      "łęczyński",
      "świdnickii",
      "chełmski",
      "Chełm",
      "krasnostawski",
      "kraśnicki",
      "sandomierski",
      "Tarnobrzeg",
      "tarnobrzeski",
      "stalowowolski",
      "janowski",
      "biłgorajski",
      "zamojski",
      "Zamość",
      "hrubieszowski",
      "tomaszowski",
      "lubaczowski",
      "jarosławski",
      "przeworski",
      "leżajski",
      "niżański",
      "łańcucki",
      "rzeszowski",
      "Rzeszów",
      "kolbuszowski",
      "mielecki",
      "dąbrowski",
      "tarnowski",
      "Tarnów",
      "dębicki",
      "ropczycko-sędziszowski",
      "brzeskii",
      "bocheński",
      "limanowski",
      "nowosądecki",
      "Nowy Sącz",
      "gorlicki",
      "jasielski",
      "krośnieński",
      "Krosno",
      "strzyżowski",
      "brzozowski",
      "sanocki",
      "leski",
      "bieszczadzki",
      "przemyski",
      "Przemyśl",
      "Kielce",
      "kielecki",
      "przysuski",
    ],
    phone: "+48 514 602 085",
    salesRepName: "Tomasz Koś",
  },
  {
    color: "#7E71B1",
    email: "p.debogorski@kns-okna.pl",
    pathId: [
      "Zielona Góra",
      "nowosolski",
      "głogowski",
      "zgorzelecki",
      "lubański",
      "bolesławiecki",
      "polkowicki",
      "lubiński",
      "górowski",
      "wołowski",
      "trzebnicki",
      "milicki",
      "legnicki",
      "Legnica",
      "lwówecki",
      "karkonoski",
      "Jelenia Góra",
      "złotoryjski",
      "kamiennogórski",
      "jaworski",
      "średzki",
      "wałbrzyski",
      "Wałbrzych",
      "świdnicki",
      "wrocławski",
      "Wrocław",
      "oleśnicki",
      "brzeski",
      "oławski",
      "opolski",
      "Opole",
      "namysłowski",
      "kluczborski",
      "oleski",
      "strzeliński",
      "dzierżoniowski",
      "kłodzki",
      "ząbkowicki",
      "nyski",
      "prudnicki",
    ],
    phone: "+48 880 175 440",
    salesRepName: "Przemysław Dębogórski",
  },
];

// Powiaty o tych samych nazwach mają w SVG ID z literówką (np. "ostrowskii"),
// w etykietach dopisujemy województwo, aby było jasne, o który chodzi.
const COUNTY_LABEL_OVERRIDES: Record<string, string> = {
  bielski: "bielski (śląskie)",
  bielskii: "bielski (podlaskie)",
  brzeski: "brzeski (opolskie)",
  brzeskii: "brzeski (małopolskie)",
  krośnieński: "krośnieński (podkarpackie)",
  krośnieńskii: "krośnieński (lubuskie)",
  lesczyński: "leszczyński",
  opollski: "opolski (lubelskie)",
  opolski: "opolski (opolskie)",
  ostrowski: "ostrowski (wielkopolskie)",
  ostrowskii: "ostrowski (mazowieckie)",
  tomaszowski: "tomaszowski (lubelskie)",
  tomaszowskii: "tomaszowski (łódzkie)",
  średzki: "średzki (dolnośląskie)",
  średzkii: "średzki (wielkopolskie)",
  świdnicki: "świdnicki (dolnośląskie)",
  świdnickii: "świdnicki (lubelskie)",
};

export const formatCountyLabel = (pathId: string) => {
  const name = COUNTY_LABEL_OVERRIDES[pathId] ?? pathId;
  return name && name[0] === name[0].toUpperCase()
    ? name // Miasto - bez słowa "powiat"
    : `powiat ${name}`; // Powiat - ze słowem "powiat"
};
